/**
 * External Imports
 */
import styled from 'styled-components';

export const ReportContainer = styled.div`
  height: calc(100vh - 128px);
  display: flex;
  flex-direction: column;
`;

export const CReportContainer = styled.div`
  height: calc(100vh - 128px);
  display: flex;
  flex-direction: column;
`;

/**
 * Styled components for the Summary Reports Views
 */

export const SummaryReportContainer = styled.div`
  height: calc(100vh - 128px);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CTSMetricChartsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const TSMetricChartsContainer = styled.div`
  display: flex;
  width: 50%;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
`;
